var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPermission || _vm.showTip)?_c('div',{staticClass:"permission-container"},[(_vm.hasPermission)?_vm._t("default"):_vm._e(),_vm._v(" "),(!_vm.hasPermission && _vm.showTip)?_c('div',{staticClass:"permission-tip"},[_vm._v(_vm._s(_vm.tip))]):_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e15dd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/container/PermissionContainer.vue
// module id = null
// module chunks = 